<template>
  <div class="problemId">
    <div v-html="content"></div>
    <div class="box-btn" v-if="showzan">
      <div class="box-btn-wrap" @click="clickZan">
        <img src="../assets/img/icon_zan3.png" />
        <span>有用</span>
      </div>
    </div>
    <div class="box-btn box-hidden-wrap" v-else>
      <div class="box-btn-wrap">
        <img src="../assets/img/icon_zan4.png" />
        <span>{{zanNum}}点赞</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return { content: "" ,showzan:true,zanNum: 0};
  },
  watch: {
    $route() {
      this.getContent();
    },
  },
  created() {
    this.getContent();
  },
  methods: {
    async getContent() {
      let res = await this.$api.getPoblemDetai({ id: this.$route.params.id });
      let data = res.data;
      if (data.status == 400) return;
      this.content = data.data.content;
      this.zanNum = data.data.support_count
    },
    async clickZan(){
        let res = await this.$api.putPoblemDetai({ id: this.$route.params.id,isform:true });
        let data = res.data;
        if(data.status == 200){
            this.showzan = false;
            this.zanNum ++
        }
    }
  },
};
</script>
<style lang="less">
.problemId {
  padding: 0 20px 70px;
  font-size: 14px;
  color: #666;
  p {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    line-height: 20px;
  }
}
strong span {
  font-weight: bold !important;
}
.box-btn{
    position: fixed;
    left: 0;
    bottom: 0px;
    width: 100%;
    padding-bottom: 10px;
    background-color: #fff;
    .box-btn-wrap{
        width: 84%;
        height: 40px;
        margin-left: 8%;
        background-color: #F7F7F9;
        border-radius: 20px;
        color: #34DDA5;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;    
        img{
            width: 18px;
            margin-right: 3px;
        }
    }
    &.box-hidden-wrap .box-btn-wrap{
        color: #8799AC;
    }
}
</style>